import { useEffect, useState } from "react";
import Image from 'react-bootstrap/Image';
import { getMetadata, getThumbnails } from 'video-metadata-thumbnails';
import Spinner from 'react-bootstrap/Spinner';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { connect } from 'react-redux';

import './style.scss';

import DefaultVideoThumb from '../../images/video_thumb.png';
import MediaThumb from '../../images/media.jpg';

const FileSpinner = () => (
    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1 }}>
        <Spinner size="sm" animation="border" variant="primary" style={{ marginLeft: '42%', marginTop: '42%' }} />
    </div>
);

const PMedia = ({
    file,
    index,
    remove,
    isDragging = false,
    progress,
    width = 80,
    height = 80,
    removable = true,
    activePost
}) => {
    const [fileType, setFiletype] = useState('');
    const [extension, setExtension] = useState('');
    const [videoThumb, setVideoThumb] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isHEVC, setIsHEVC] = useState(false);

    useEffect(() => {
        if (file.file && file.file.type) {
            if (file.file.name) {
                const extension = file.file.name.split('.');
                setExtension(extension[extension.length - 1].toUpperCase());
            } else {
                const type = file.file.type.split('/');
                setExtension(type[1].toUpperCase());
            }

            if (file.file.type.indexOf('image') >= 0) {
                setFiletype('image');
            }

            if (file.file.type.indexOf('video') >= 0) {
                generateThumb(file.file);
                setFiletype('video');
            }
        }
    }, [file]);

    const generateThumb = async (video) => {
        try {
            setIsLoading(true);
            const thumbnails = await getThumbnails(video, {
                interval: 1,
                start: 0,
                end: 0
            });
            setVideoThumb(URL.createObjectURL(thumbnails[0].blob));
        } catch (error) {
            setIsHEVC(true);
            setVideoThumb(DefaultVideoThumb);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRemove = (e) => {
        e.preventDefault();
        remove(file);
    };

    switch (fileType) {
        case 'image':
            return (
                <div className="media" style={{ width: `${width}px`, height: `${height}px` }}>
                    {
                        removable && <i className="media__remove d-none d-md-block" onClick={(e) => handleRemove(e)} />
                    }
                    {
                        file.loaded < 100 && <FileSpinner />
                    }
                    {
                        file.loaded < 100 && <div style={{
                            zIndex: 999,
                            position: 'absolute',
                            bottom: '4px',
                            width: '100%',
                            // left: '8px',
                            padding: '4px 6px'
                        }}>
                            <ProgressBar
                                now={progress[file.uuid]}
                                animated={true}
                                min={5}
                                style={{ width: '100%', height: '10px' }}
                            />
                        </div>
                    }
                    <span className="media__type">
                        {extension}
                    </span>
                    <Image style={{ width: `${width}px`, height: `${height}px`, objectFit: 'cover' }} src={file.image} fluid />
                </div>
            );
        case 'video':
            return (
                <div className="media" style={{ width: `${width}px`, height: `${height}px` }}>
                    {removable && <i className="media__remove" onClick={(e) => handleRemove(e)} />}
                    <span className="media__type">
                        {extension} {isHEVC ? 'HEVC' : ''}
                    </span>
                    {
                        file.loaded < 100 && <FileSpinner />
                    }
                    {
                        file.loaded < 100 && <div style={{
                            zIndex: 999,
                            position: 'absolute',
                            bottom: '4px',
                            width: '100%',
                            padding: '4px 6px'
                        }}>
                            <ProgressBar
                                now={progress[file.uuid]}
                                animated={true}
                                min={5}
                                style={{ width: '100%', height: '10px' }}
                            />
                        </div>
                    }
                    {
                        fileType === 'image' && <Image src={file.image} style={{ width: `${width}px`, height: `${height}px`, objectFit: 'cover' }} fluid rounded />
                    }
                    {
                        fileType === 'video' && videoThumb && <Image src={videoThumb} style={{ width: `${width}px`, height: `${height}px`, objectFit: 'cover' }} fluid rounded />
                    }
                    {/* {
            isLoading && !isDragging && !videoThumb && <Spinner animation="border" size="sm" style={{zIndex: 999}} />
          } */}
                </div>
            );

        default:
            console.log('default loaded');
            return <div className="media" style={{ width: `${width}px`, height: `${height}px` }}>
                <Image src={MediaThumb} style={{ width: `${width}px`, height: `${height}px`, objectFit: 'cover' }} fluid rounded />
            </div>;
    }
};

const mapStateToProps = state => {
    return {
        activePost: state.post.selectedPost
    };
};

export default connect(mapStateToProps)(PMedia);